document.addEventListener('DOMContentLoaded',()=>{

  const fadeEls=document.querySelectorAll('.fade-up');

  const io=new IntersectionObserver(
    es=>es.forEach(e=>{
      if(e.isIntersecting)e.target.classList.add('is-visible');
    }),
    {threshold:.1}
  );

  fadeEls.forEach(e=>io.observe(e));


  /* MENU */

  const menu=document.querySelector('#GioraMenu');
  const menuBack=document.querySelector('#MenuBackdrop');

  const openMenu=()=>{
    menu?.classList.add('open');
    menuBack?.classList.add('open');
    document.body.classList.add('drawer-lock');
    menu?.setAttribute('aria-hidden','false');
  };

  const closeMenu=()=>{
    menu?.classList.remove('open');
    menuBack?.classList.remove('open');
    document.body.classList.remove('drawer-lock');
    menu?.setAttribute('aria-hidden','true');
  };

  document.querySelectorAll('[data-menu-open]')
    .forEach(b=>b.addEventListener('click',openMenu));

  document.querySelectorAll('[data-menu-close]')
    .forEach(b=>b.addEventListener('click',closeMenu));


  /* CARRINHO */

  const drawer=document.querySelector('#GioraCart');
  const back=document.querySelector('#CartBackdrop');

  const openCart=()=>{
    drawer?.classList.add('open');
    back?.classList.add('open');
    document.body.classList.add('drawer-lock');
  };

  const closeCart=()=>{
    drawer?.classList.remove('open');
    back?.classList.remove('open');
    document.body.classList.remove('drawer-lock');
  };

  document.querySelectorAll('[data-cart-open]')
    .forEach(b=>b.addEventListener('click',openCart));

  document.addEventListener('click', function(e) {
  if (e.target.closest('[data-cart-close]')) {
    closeCart();
  }
});


  /* BUSCA */

  const search=document.querySelector('#GioraSearch');

  document.querySelectorAll('[data-search-open]')
    .forEach(b=>b.addEventListener('click',()=>{
      search?.classList.add('open');
      document.body.classList.add('drawer-lock');
    }));

  document.querySelectorAll('[data-search-close]')
    .forEach(b=>b.addEventListener('click',()=>{
      search?.classList.remove('open');
      document.body.classList.remove('drawer-lock');
    }));


  /* ESC */

  document.addEventListener('keydown',e=>{
    if(e.key==='Escape'){
      closeMenu();
      closeCart();
      search?.classList.remove('open');
      document.body.classList.remove('drawer-lock');
    }
  });


/* CONTROLES DE QUANTIDADE DO CARRINHO */
document.addEventListener('click', async function(e) {
  const button = e.target.closest('.cart-qty-btn, .cart-remove-btn');
  if (!button) return;

  e.preventDefault();
  e.stopImmediatePropagation();

  const action = button.dataset.cartAction;
  if (!action) return;

  const cartItem = button.closest('.cart-item');
  const controls = button.closest('.cart-qty-controls');
  const quantityElement = controls?.querySelector('.cart-qty-number');

  if (!cartItem || !quantityElement) return;

  const cartItems = Array.from(
    document.querySelectorAll('.cart-item')
  );

  const line = cartItems.indexOf(cartItem) + 1;

  const currentQuantity = parseInt(
    quantityElement.textContent.trim() || '1',
    10
  );

  let newQuantity = currentQuantity;

  if (action === 'increase') {
    newQuantity = currentQuantity + 1;
  }

  if (action === 'decrease') {
    newQuantity = Math.max(1, currentQuantity - 1);
  }

  if (action === 'remove') {
    newQuantity = 0;
  }

  try {
    const response = await fetch(
      (window.Shopify?.routes?.root || '/') + 'cart/change.js',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          line: line,
          quantity: newQuantity
        })
      }
    );

    const data = await response.json();

    if (!response.ok) {
      console.error('ERRO SHOPIFY:', data);
      throw new Error(
        data.description || data.message || 'Erro ao atualizar carrinho'
      );
    }

    const pageResponse = await fetch(
      window.location.pathname + '?cart_refresh=' + Date.now(),
      { cache: 'no-store' }
    );

    const html = await pageResponse.text();

    const doc = new DOMParser().parseFromString(html, 'text/html');

    const newCart = doc.querySelector('#GioraCart');
    const currentCart = document.querySelector('#GioraCart');

    if (newCart && currentCart) {
      currentCart.innerHTML = newCart.innerHTML;
    }

    const newCount = doc.querySelector('.cart-count');

    document.querySelectorAll('.cart-count').forEach(function(el) {
      if (newCount) {
        el.textContent = newCount.textContent;
      }
    });

  } catch (error) {
    console.error('ERRO DO CARRINHO:', error);
    alert('ERRO: ' + (error.message || error));
  }
});

});
/* CORES DOS PRODUTOS NA COLEÇÃO */

document.addEventListener('click', function(e) {
  const swatch = e.target.closest('[data-card-swatch]');
  if (!swatch) return;

  e.preventDefault();
  e.stopPropagation();

  const card = swatch.closest('[data-product-card]');
  if (!card) return;

  const image = card.querySelector('.card-main-image');
  if (!image) return;

  const newImage = swatch.getAttribute('data-image');
  if (!newImage) return;

  /* Remove o srcset antigo para o navegador não voltar para a foto original */
  image.removeAttribute('srcset');
  image.removeAttribute('sizes');

  /* Troca a foto */
  image.src = newImage;

  /* Marca a cor selecionada */
  card.querySelectorAll('[data-card-swatch]').forEach(function(button) {
    button.classList.remove('is-active');
  });

  swatch.classList.add('is-active');
});